export const color = {
  green: "#58561D",
  lilac: "#D7D0E7",
  lightBlue: "#BCC9DA",
  navyBlue: "#39475E",
  tan: "#E3C6AD",
  brown: "#401B0E",
  pink: "#F8DFDB",
  red: "#E73B37",
};

export const getNextColor = (c) => {
  switch (c) {
    case "green":
      return color["lilac"];
      break;
    case "lilac":
      return color["lightBlue"];
      break;
    case "lightBlue":
      return color["navyBlue"];
      break;
    case "navyBlue":
      return color["tan"];
      break;
    case "tan":
      return color["brown"];
      break;
    case "brown":
      return color["pink"];
      break;
    case "pink":
      return color["red"];
      break;
    default:
      return color["lilac"];
      break;
  }
};

export const stringToColor = (string) => {
  if (!string) {
    return "white";
  }
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};
